<script lang="ts">
  import { getModalStore } from '@skeletonlabs/skeleton';

  const modalStore = getModalStore();
  export let parent: any;

  const onConfirm = $modalStore[0]?.meta?.onConfirm;
  const clientId = $modalStore[0]?.meta?.clientId;
  const clientName = $modalStore[0]?.meta?.clientName;
  
  let certificatePassword: string = '';
  let certificateFile: string = '';
  let fileInput: HTMLInputElement;
  let error = '';

  function uploadCertificate() {
    fileInput.click();
  }

  function handleFileUpload(event: Event) {
    const target = event.target as HTMLInputElement;
    const file = target.files?.[0];
    if (file) {
      const reader = new FileReader();
      reader.onload = (e) => {
        const arrayBuffer = e.target?.result as ArrayBuffer;
        const bytes = new Uint8Array(arrayBuffer);
        certificateFile = btoa(String.fromCharCode(...bytes));
      };
      reader.readAsArrayBuffer(file);
    }
  }

  async function onFormSubmit() {
    error = '';
    if (!certificateFile) {
      error = 'Please upload a certificate file.';
      return;
    }
    if (!certificatePassword) {
      error = 'Please enter the certificate password.';
      return;
    }
    try {
      await onConfirm({
        clientId,
        certificateFile,
        certificatePassword
      });
      modalStore.close();
    } catch (err) {
      error = err instanceof Error ? err.message : 'Error saving certificate';
    }
  }

  function handleCancel() {
    modalStore.close();
  }
</script>

{#if $modalStore[0]}
  <div class="card w-modal flex max-h-[80vh] flex-col shadow-xl">
    <header class="p-4 text-2xl font-bold">Upload new Certificate</header>
    <div class="flex-grow overflow-y-auto p-4">
        {#if error}
        <div class="card mb-4 bg-error-500 p-4 text-white">
            <p>{error}</p>
        </div>
        {/if}
        <form class="space-y-4 border border-surface-500 p-4 rounded-container-token">
            <label class="label">
                <span>Client ID</span>
                <input class="input" type="text" value={clientId} readonly />
            </label>
            <label class="label">
                <span>Client Name</span>
                <input class="input" type="text" value={clientName} readonly />
            </label>
            <label class="label">
                <span>Certificate Password</span>
                <input class="input" type="text" bind:value={certificatePassword} />
            </label>
            <div class="label">
                <span>Certificate File {certificateFile ? '(Uploaded)' : ''}</span>
                <div class="flex space-x-2">
                    <button class="variant-filled btn" on:click={uploadCertificate}>Upload Certificate</button>
                    <input type="file" accept=".pfx" style="display: none;" bind:this={fileInput} on:change={handleFileUpload} />
                </div>
            </div>


        </form>

    </div>

    <footer class="modal-footer {parent.regionFooter} p-4">
        <button class="btn {parent.buttonNeutral}" on:click={handleCancel}>Cancel</button>
        <button class="btn {parent.buttonPositive}" on:click={onFormSubmit}>Save Certificate</button>
    </footer>
  </div>
{/if}
